const sideBar = document.querySelector('.klub-page .klub-sidebar');
const pageLayoutMain = document.querySelector('.PageLayout__main-page--klub');
let screenWidth = window.innerWidth;

if (sideBar && screenWidth < 1300) mobileSidebar();

function mobileSidebar() {
	const urlParams = new URLSearchParams(window.location.search);
	let pageLevel;
	if (urlParams.size !== 0) {
		pageLevel = urlParams.get('level')
		if (pageLevel === null) {
			pageLevel = '1';
		}
	}
	else pageLevel = '1';

	if (pageLevel === '2') renderPageLevelTwo();
	if (pageLevel === '1') renderPageLevelOne();

	backSectionNavigation();
	sideBar.querySelectorAll('.sidebar__wrapper .sidebar-item__wrapper a').forEach(sidebarItemLink => {
		sidebarItemLink.addEventListener('click', (event) => activateMobileSidebarItem(event, sidebarItemLink))
	});
}

function activateMobileSidebarItem(event, sidebarItemLink) {
	event.preventDefault();
	const sidebarItem = sidebarItemLink.closest('.sidebar-item__wrapper');

	if (!sidebarItem) return;
	let sidebarHref = sidebarItemLink.getAttribute('href');
	if (!sidebarHref || sidebarHref === '') return;

	let sidebarItemClasses = sidebarItem.classList;
	if (sidebarItemClasses.length === 0) return;
	sidebarItemClasses = Array.from(sidebarItemClasses);
	const isSlidebarPageCurrentlyActive = sidebarItemClasses.includes('selected');
	if (isSlidebarPageCurrentlyActive) {
		renderPageLevelTwo()
	}
	else {
		let sidebarHrefIncludesViewQueryParam = sidebarHref.includes('?view');
		let sidebarHrefModified = '';
		if (sidebarHrefIncludesViewQueryParam) sidebarHrefModified = sidebarHref + '&level=2'
		else sidebarHrefModified = sidebarHref + '?level=2'
		location.href = sidebarHrefModified;
	}

}

function renderPageLevelTwo() {
	const pageLayout = document.querySelector('.PageLayout--klub');
	sideBar.classList.add("d-none", "d-xl-block");
	if (!pageLayout || !pageLayoutMain) return;
	if (pageLayoutMain.classList.contains('d-none') && pageLayoutMain.classList.contains('d-xl-block')) {
		pageLayoutMain.classList.remove("d-none");
		pageLayoutMain.classList.remove("d-xl-block");
	}

	backSectionNavigation()
}

function renderPageLevelOne() {
	const pageLayout = document.querySelector('.PageLayout--klub');
	if (!pageLayout || !pageLayoutMain) return;
	sideBar.classList.remove("d-none", "d-xl-block");
	if (!pageLayoutMain.classList.contains('d-none') && !pageLayoutMain.classList.contains('d-xl-block')) pageLayoutMain.classList.add("d-none", "d-xl-block");
}


function backSectionNavigation() {
	const backSectionNavigations = document.querySelectorAll('.back-section__wrapper');
	backSectionNavigations.forEach(backSectionNavigation => {
		backSectionNavigation.addEventListener('click', () => renderPageLevelOne());
	})
}


function debounce(func, delay) {
	let timeoutId;
	return function (...args) {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

let lastWidth = window.innerWidth;

function handleResize() {
	let screenWidth = window.innerWidth;
	if (sideBar && screenWidth < 1300) mobileSidebar();
}

function checkResize() {
	const currentWidth = window.innerWidth;
	if (Math.abs(currentWidth - lastWidth) >= 10) {
		lastWidth = currentWidth;
		handleResize();
	}
}

const debouncedCheckResize = debounce(checkResize, 200);
window.addEventListener('resize', debouncedCheckResize);
